import React, { useState, useRef, useEffect } from 'react';
import { Play, Pause, SkipBack, SkipForward, Volume2, Moon, Sparkles, ChevronLeft, ChevronRight, Repeat } from 'lucide-react';

const LullabyCarousel = () => {
  const [currentTrack, setCurrentTrack] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isLooping, setIsLooping] = useState(false);
  const audioRef = useRef(null);
  const carouselRef = useRef(null);

  // Collection de berceuses avec l'audio fourni et d'autres berceuses
  const lullabies = [
    {
      id: 1,
      title: "Sweet Dreams",
      artist: "Moment of Serenity",
      duration: "3:42",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494850/20250818_1045_Koala_Cosmique_Re%CC%82veur_remix_01k2xa3r0sfxvbjeks6tex4382_hpe0wr.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_whizz-stories-7/artifacts/y8rfw8r4_Dreamy%20Lullaby.mp3",
      color: "from-purple-400 to-pink-400"
    },
    {
      id: 2,
      title: "Gentle Breeze",
      artist: "Moment of Serenity",
      duration: "4:15",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494904/20250818_1056_Dauphin_Nuageux_Cosmique_remix_01k2xaqq4pfqgv4f2dxnsmkm3x_x8liim.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_ai-storyteller-12/artifacts/obcdubez_Dreamy%20Whispers.mp3",
      color: "from-blue-400 to-indigo-400"
    },
    {
      id: 3,
      title: "Starry Night",
      artist: "Moment of Serenity",
      duration: "3:58",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494929/20250818_1120_Voiture_Nuage_Cosmique_remix_01k2xc2v2reewa5twtsewgz4k3_glsgu1.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_ai-storyteller-12/artifacts/3gkqkcu8_Dreamland%20Lullaby.mp3",
      color: "from-teal-400 to-cyan-400"
    },
    {
      id: 4,
      title: "Ocean Waves",
      artist: "Moment of Serenity",
      duration: "4:32",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494878/20250818_1050_Nuage_Ourson_Spatial_remix_01k2xabkmefwp9fa0rarwc7p2n_t6j9kd.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_ai-storyteller-12/artifacts/lqzbdjra_Starry%20Whispers%20copie%202.mp3",
      color: "from-green-400 to-emerald-400"
    },
    {
      id: 5,
      title: "Forest Song",
      artist: "Moment of Serenity",
      duration: "5:20",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494923/20250818_1058_Lion_Nuageux_Ce%CC%81leste_remix_01k2xatjjfetgr0ra106pg52k5_dc2mj2.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_ai-storyteller-12/artifacts/tpf7ei1b_Twilight%20Lullaby.mp3",
      color: "from-cyan-400 to-blue-400"
    },
    {
      id: 6,
      title: "Angel's Rest",
      artist: "Moment of Serenity",
      duration: "6:10",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494901/20250818_1052_Dinosaure_Nuageux_Cosmique_remix_01k2xafq8xfpdtc0jarpj19sn0_fwejwr.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_ai-storyteller-12/artifacts/2lkux3wh_Twilight%20Lullaby%20copie.mp3",
      color: "from-gray-400 to-slate-400"
    },
    {
      id: 7,
      title: "Moonlit Path",
      artist: "Moment of Serenity",
      duration: "4:05",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494836/20250818_0825_E%CC%81le%CC%81phant_Cosmique_Re%CC%82veur_remix_01k2x22rvhe8ytrqgvscphs7hh_dvh1mj.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_ai-storyteller-12/artifacts/gxyyrwqf_Starry%20Whispers%20copie.mp3",
      color: "from-yellow-400 to-orange-400"
    },
    {
      id: 8,
      title: "Cozy Embrace",
      artist: "Moment of Serenity",
      duration: "3:28",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494936/20250818_1211_Piano_Nuageux_Spatial_remix_01k2xezjp8eh3rbm752tgj86dc_yuc1lk.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_ai-storyteller-12/artifacts/s3ubnvnh_Starry%20Whispers.mp3",
      color: "from-rose-400 to-pink-400"
    },
    {
      id: 9,
      title: "Sleepy Clouds",
      artist: "Moment of Serenity",
      duration: "4:45",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494872/20250818_1049_Requin_Gentil_Cosmique_remix_01k2xaa1jdep4vvzbmrjmyky5n_cmdz4a.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_ai-storyteller-12/artifacts/rh1uye28_Moonlit%20Dreams%20copie.mp3",
      color: "from-violet-400 to-purple-400"
    },
    {
      id: 10,
      title: "Peaceful Garden",
      artist: "Moment of Serenity",
      duration: "3:15",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494865/20250818_1047_Nuage_Dinosaure_Spatial_remix_01k2xa6cedeqgb4hb7qaay8kwd_a5h19e.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_ai-storyteller-12/artifacts/044mrcrn_Moonlit%20Dreams.mp3",
      color: "from-sky-400 to-blue-400"
    },
    {
      id: 11,
      title: "Magic Castle",
      artist: "Moment of Serenity",
      duration: "5:03",
      coverArt: "https://res.cloudinary.com/dogguvwef/image/upload/v1755494896/20250818_1051_Nuages_et_Plane%CC%80tes_Fantaisie_remix_01k2xadq33em79ev5efwwaw0k9_tsxinu.png",
      audioUrl: "https://customer-assets.emergentagent.com/job_ai-storyteller-12/artifacts/y9a9b00a_Dreamland%20Waltz.mp3",
      color: "from-emerald-400 to-teal-400"
    }
  ];

  const currentLullaby = lullabies[currentTrack];

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const updateTime = () => setCurrentTime(audio.currentTime);
    const updateDuration = () => setDuration(audio.duration);

    audio.addEventListener('timeupdate', updateTime);
    audio.addEventListener('loadedmetadata', updateDuration);

    return () => {
      audio.removeEventListener('timeupdate', updateTime);
      audio.removeEventListener('loadedmetadata', updateDuration);
    };
  }, [currentTrack]);

  useEffect(() => {
    if (carouselRef.current) {
      const activeCard = carouselRef.current.children[currentTrack];
      if (activeCard) {
        activeCard.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }, [currentTrack]);

  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      // Pour les placeholders, on simule juste la lecture
      if (!currentLullaby.audioUrl.includes('customer-assets')) {
        // C'est un placeholder, on simule
        setTimeout(() => setIsPlaying(false), 3000);
      } else {
        audio.play().catch(console.error);
      }
    }
    setIsPlaying(!isPlaying);
  };

  const nextTrack = () => {
    setCurrentTrack((prev) => (prev + 1) % lullabies.length);
    setIsPlaying(false);
    setCurrentTime(0);
  };

  const prevTrack = () => {
    setCurrentTrack((prev) => (prev - 1 + lullabies.length) % lullabies.length);
    setIsPlaying(false);
    setCurrentTime(0);
  };

  const formatTime = (time) => {
    if (isNaN(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="bg-gradient-to-r from-indigo-900 via-purple-900 to-pink-900 rounded-2xl p-6 mb-6 shadow-2xl">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-white/10 rounded-full">
            <Moon className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-white flex items-center gap-2">
              Moment of Serenity
              <Sparkles className="w-5 h-5 text-yellow-300" />
            </h2>
          </div>
        </div>
      </div>
      
      {/* Description */}
      <div className="mb-6">
        <p className="text-purple-200 text-sm">
          After igniting their imagination, the lullaby offers a moment of pure serenity to gently drift into the world of dreams.
        </p>
      </div>

      {/* Carrousel de berceuses avec flèches de navigation */}
      <div className="mb-6 relative">
        {/* Flèche gauche */}
        <button
          onClick={prevTrack}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full p-2 transition-all duration-200 group shadow-lg"
          style={{ transform: 'translateY(-50%)' }}
        >
          <ChevronLeft className="w-6 h-6 text-white group-hover:text-purple-200 transition-colors" />
        </button>

        {/* Flèche droite */}
        <button
          onClick={nextTrack}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full p-2 transition-all duration-200 group shadow-lg"
          style={{ transform: 'translateY(-50%)' }}
        >
          <ChevronRight className="w-6 h-6 text-white group-hover:text-purple-200 transition-colors" />
        </button>

        {/* Container du carousel avec padding pour les flèches */}
        <div className="mx-12">
          <div ref={carouselRef} className="flex overflow-x-auto pb-4 gap-4 scrollbar-hide">
            {lullabies.map((lullaby, index) => (
              <div
                key={lullaby.id}
                className={`min-w-[180px] cursor-pointer transition-all duration-300 ${
                  index === currentTrack ? 'transform scale-105' : 'opacity-70 hover:opacity-100'
                }`}
                onClick={() => {
                  setCurrentTrack(index);
                  setCurrentTime(0);
                  // Auto-play après un petit délai pour laisser l'audio se charger
                  setTimeout(() => {
                    const audio = audioRef.current;
                    if (audio && !currentLullaby.audioUrl.includes('customer-assets')) {
                      // C'est un placeholder, on simule
                      setIsPlaying(true);
                      setTimeout(() => setIsPlaying(false), 3000);
                    } else if (audio) {
                      audio.play().then(() => {
                        setIsPlaying(true);
                      }).catch(console.error);
                    }
                  }, 100);
                }}
              >
                <div className="relative group">
                  <div className={`bg-gradient-to-br ${lullaby.color} p-1 rounded-2xl`}>
                    <img
                      src={lullaby.coverArt}
                      alt={lullaby.title}
                      className="w-full aspect-square object-cover rounded-xl shadow-lg"
                    />
                    {index === currentTrack && isPlaying && (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="bg-black/50 rounded-full p-3">
                          <div className="w-6 h-6 flex">
                            <div className="bg-white rounded-sm w-1 h-6 mr-1 animate-pulse"></div>
                            <div className="bg-white rounded-sm w-1 h-6 mr-1 animate-pulse delay-75"></div>
                            <div className="bg-white rounded-sm w-1 h-6 animate-pulse delay-150"></div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mt-2 text-center">
                    <h3 className={`text-sm font-semibold truncate ${
                      index === currentTrack ? 'text-white' : 'text-purple-200'
                    }`}>
                      {lullaby.title}
                    </h3>
                    <p className="text-xs text-purple-300 truncate">{lullaby.artist}</p>
                    <p className="text-xs text-purple-400">{lullaby.duration}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Lecteur principal */}
      <div className="bg-black/20 rounded-xl p-4">
        <div className="flex items-center gap-4 mb-4">
          <div className={`bg-gradient-to-br ${currentLullaby.color} p-1 rounded-xl`}>
            <img
              src={currentLullaby.coverArt}
              alt={currentLullaby.title}
              className="w-16 h-16 object-cover rounded-lg"
            />
          </div>
          <div className="flex-1">
            <h3 className="text-white font-semibold text-lg">{currentLullaby.title}</h3>
            <p className="text-purple-200">{currentLullaby.artist}</p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={prevTrack}
              className="p-2 hover:bg-white/10 rounded-full transition-colors"
            >
              <SkipBack className="w-5 h-5 text-white" />
            </button>
            <button
              onClick={togglePlay}
              className="p-3 bg-white/20 hover:bg-white/30 rounded-full transition-colors"
            >
              {isPlaying ? (
                <Pause className="w-6 h-6 text-white" />
              ) : (
                <Play className="w-6 h-6 text-white ml-0.5" />
              )}
            </button>
            <button
              onClick={nextTrack}
              className="p-2 hover:bg-white/10 rounded-full transition-colors"
            >
              <SkipForward className="w-5 h-5 text-white" />
            </button>
            <button
              onClick={() => setIsLooping(!isLooping)}
              className={`p-2 hover:bg-white/10 rounded-full transition-colors ${isLooping ? 'bg-white/20' : ''}`}
            >
              <Repeat className="w-5 h-5 text-white" />
            </button>

          </div>
        </div>

        {/* Barre de progression */}
        <div className="flex items-center gap-3">
          <span className="text-xs text-purple-300 min-w-[35px]">
            {formatTime(currentTime)}
          </span>
          <div className="flex-1 h-1 bg-white/20 rounded-full cursor-pointer">
            <div 
              className="h-full bg-white rounded-full transition-all duration-100"
              style={{ width: duration ? `${(currentTime / duration) * 100}%` : '0%' }}
            ></div>
          </div>
          <span className="text-xs text-purple-300 min-w-[35px]">
            {currentLullaby.duration}
          </span>
        </div>
      </div>

      {/* Audio element */}
      <audio
        ref={audioRef}
        src={currentLullaby.audioUrl}
        loop={isLooping}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => {
          setIsPlaying(false);
          if (!isLooping) {
            nextTrack();
          }
        }}
      />
    </div>
  );
};

export default LullabyCarousel;